module.exports = __webpack_public_path__ + "6c6aeb4d2cbcbf24d5aa.worklet.js";